import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import UnitWeightEditor from 'components/desktop/_general/UnitWeightEditor/UnitWeightEditor';
import { Characteristic } from 'enums/characteristic';
import { usePermissions } from 'hooks/usePermissions';
import * as UnitList from 'types/_general/Store/UnitList';

export const IngredientWeightCard = ({
	state,
	handlers,
	data,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const { isIngredientEditor } = usePermissions();

	return (
		<FoldableCard
			unlockable={isIngredientEditor}
			dataComponentType="ingredient-weight-card"
			defaultOpen={true}
			title={t('baseIngredient:WEIGHT')}
			hasLock={true}
			defaultLocked={state.locked.unitWeights}
			handleLockClick={(input: boolean) =>
				input ? handlers.lock('unitWeights') : handlers.unlock('unitWeights')
			}
			content={
				<div className="card-body">
					<UnitWeightEditor
						units={UnitList.mapToUnitLightList(
							UnitList.getByCharacteristic(
								data.units,
								state.characteristic ?? Characteristic.SolidNonQuantifiable
							)
						)}
						unitWeights={state.unitWeights}
						setUnitWeights={handlers.setUnitWeights}
						disabled={!isIngredientEditor}
					/>
				</div>
			}
		/>
	);
};
